var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import HTTP from "@/http";
var Filters = (function (_super) {
    __extends(Filters, _super);
    function Filters() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.form = {
            tagIds: [],
            time: "",
            sort: "-created_at",
        };
        _this.tags = [];
        _this.times = [
            { value: "", text: 'Any Time' },
            { value: "1", text: 'Today' },
            { value: "7", text: 'This week' },
            { value: "30", text: 'This month' },
        ];
        _this.sorts = [
            { value: "-created_at", text: 'Time added' },
            { value: "likes", text: 'Likes' },
        ];
        return _this;
    }
    Filters.prototype.getTags = function () {
        var _this = this;
        HTTP.get("tags", { params: { all: true } })
            .then(function (response) {
            _this.tags = response.data;
        })
            .catch(function (response) {
        });
    };
    Filters.prototype.onInputChange = function () {
        this.$emit("input", this.form);
    };
    Filters.prototype.created = function () {
        this.getTags();
    };
    __decorate([
        Watch("form", { deep: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Filters.prototype, "onInputChange", null);
    Filters = __decorate([
        Component
    ], Filters);
    return Filters;
}(Vue));
export default Filters;



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/Pages/PageBrowseTracksFilters.vue
// module id = 230
// module chunks = 0